<template>
    <el-dialog
            :title="editTextConfig.title"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            @close="reset"
            width="700px">

        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item :label="formTextConfig.realname" prop="realname">
                <el-input v-model="form.realname" maxlength="20" show-word-limit></el-input>
            </el-form-item>
        </el-form>

        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item :label="formTextConfig.idCardNo" prop="idCardNo">
                <el-input v-model="form.idCardNo" maxlength="18" show-word-limit></el-input>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{ formTextConfig.cancel }}</el-button>
            <el-button type="primary" @click="updateUser">{{ formTextConfig.ok }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {updateUser} from "@/api/user";

export default {
    props: ['user'],
    data() {
        return {
            dialogVisible: false,
            form: {
                id: null,
                realname: null
            },
            rules: {
                realname: [
                    {required: true, message: "姓名不能为空", trigger: "blur"},
                    {min: 2, max: 20, message: '姓名长度必须介于 2 和 20 之间', trigger: 'blur'},
                ]
            }
        }
    },
    computed: {
        editTextConfig() {
            return this.$store.state.global.textConfig.backend.reviewer.button.edit
        },
        formTextConfig() {
            return this.editTextConfig.form
        },
    },
    watch: {
        user() {
            this.form = this.user
        }
    },
    methods: {
        open() {
            this.dialogVisible = true
        },
        updateUser() {
            this.$refs.form.validate(vaild => {
                if (vaild) {
                    updateUser(this.form.id, this.form).then(res => {
                        if (res.status === 200) {
                            this.$message.success('编辑成功')
                            this.dialogVisible = false
                            this.$emit('success')
                        }
                    })
                }
            })
        },
        reset() {
            this.form = {
                id: null,
                realname: null
            }
            this.$refs.form.resetFields()
        }
    }
}
</script>

<style scoped>

</style>
